import "./sass/style.scss";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);


$(function(){
  $(function () {
    $(".js_inview_scaleUp").on("inview", function () {
      $(this).addClass("is_fired");
    });
  });

  $(".un_new2024Firstview_show_close").click(function () {
    $(".un_new2024Firstview_show").fadeOut("500");
  });

  /* MVのブラックフェードアウトと同期させるため、オートプレイはしないで実行 */
  $('.un_new2024Firstview_visual_slider').on('init', function(){
    $('.slick-slide[data-slick-index="0"]').addClass('zooming');
  })
  $('.un_new2024Firstview_visual_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 5000,
    speed: 2000,
    pauseOnHover: false,
    infinite: true,
    arrows: false,
    dots: false,
    fade: true
  })
    .on({
      beforeChange: function(event, slick, currentSlide, nextSlide) {
        $(".slick-slide", this).eq(currentSlide).addClass("preve-slide");
        $(".slick-slide", this).eq(nextSlide).addClass("zooming");
      },
      afterChange: function() {
        $(".preve-slide", this).removeClass("preve-slide zooming");
      }
  });
  

  $('.un_new2024Tuguca_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    infinite: true,
    arrows: false,
    dots: false,
    fade: true
  });

  // 各スライダーコンテナに対して処理
  $('.un_new2024Rigelpro_item_slider').each(function() {
    var $sliderContainer = $(this);
    // スライダー要素の数を確認
    if ($sliderContainer.find('.un_new2024Rigelpro_item_slide').length >= 2) {
      // スライダー要素が1個以上の場合にslickを初期化
      $sliderContainer.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 1000,
        arrows: false,
        dots: true,
        fade: true
      });
    }
  });

  // システムオフトン
  $('.un_new2024Systemofuton_imgArea_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    arrows: false,
    dots: true,
    fade: true
  });
 
  $('.un_new2024TakibiSandSkillet_item_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 1000,
    arrows: false,
    dots: true,
    fade: true
  });

  $('.un_new2024Sayou_item_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 1000,
    arrows: false,
    dots: true,
    fade: true
  });

  $('.un_new2024AlphaBreeze_item_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 1000,
    arrows: false,
    dots: true,
    fade: true
  });

  $('.un_new2024Show_firstview_slider').on('init', function(){
    $('.slick-slide[data-slick-index="0"]').addClass('moving');
  })
  .slick({
    pauseOnFocus: false,
    pauseOnHover: false,
    infinite:true,
    autoplay:true,
    autoplaySpeed:4000,
    speed: 2000,
    arrows:false,
    fade:true,
  })
    .on({
      beforeChange: function(event, slick, currentSlide, nextSlide) {
        $(".slick-slide", this).eq(currentSlide).addClass("preve-slide");
        $(".slick-slide", this).eq(nextSlide).addClass("moving");
      },
      afterChange: function() {
        $(".preve-slide", this).removeClass("preve-slide moving");
      }
    });
  // spw faq click
  if( $('.eventFaq').length ) {
    $('.eventFaq li p:first-child').on('click',function(){
      $(this).next().slideToggle();
    });
  }
  // inview
  // フェードイン
  $('.inviewfadeIn').on('inview', function(event, isInView, visiblePartX, visiblePartY) {
    if (isInView) {
      $(this).stop().addClass('fadeIn');
    } else {
      //$(this).stop().removeClass('fadeIn');
    }
  });

});




/* ----------------------------------
ローディング
---------------------------------- */

const loading = document.getElementById('loading');
/* 読み込み完了 */
window.addEventListener('load', stopload);

/* 10秒経ったら強制的にロード画面を非表示にする */
setTimeout(function() {
  if (loading && !loading.classList.contains('is-loaded')) {
    stopload();
  }
}, 10000);

/* ロード画面を非表示にする処理 */
function stopload(){
  // meta ogpのURLの末尾がnew2026/で、ページの表示位置が一番上の場合
  var ogUrlMeta = document.querySelector('meta[property="og:url"]');
  if(ogUrlMeta){
    var ogUrl = ogUrlMeta.getAttribute('content') || '';
    if(ogUrl.endsWith('new2026/')) {
      // ページが一番上にいる場合
      if (window.pageYOffset === 0) {
        loading.classList.add('is-firstview');
      }
    }
  }

  loading.classList.add('is-loaded');

  /* メインビジュアルフェード処理開始（CSS連動、1.7秒後 #loading.is-loaded） */
  setTimeout(function() {
    $('.un_new2024Firstview_visual_slider').slick('slickPlay');
  }, 3700); // 1700ミリ秒 = 1.7秒

  /* スクロール連動拡大 */
  document.querySelectorAll(".un_new2024ScaleUp").forEach((el) => {
    gsap.to(el, {
      scale: 1,
      scrollTrigger: {
        trigger: el,//アニメーションが始まるトリガーとなる要素
        start: 'top bottom', //アニメーションが始まる位置
        end: 'bottom bottom', //アニメーションが終わる位置
        scrub: true, //スクロール量に合わせてアニメーションが進む（数字も指定できる）
        // markers: true,
      }
    });
  });

}

/* ----------------------------------
スムーススクロール
---------------------------------- */
document.addEventListener("click", e => {
  const target = e.target;
  // clickした要素がclass属性、smooth-scrollを含まない場合は処理を中断
  if (!target.classList.contains("smoothscroll")) return;
  e.preventDefault();
  const targetId = target.hash;
  const targetElement = document.querySelector(targetId);
  // 画面上部から要素までの距離
  const rectTop = targetElement.getBoundingClientRect().top;
  // 現在のスクロール距離
  const offsetTop = window.pageYOffset;
  // スクロール位置に持たせるバッファ
  const buffer = 100;
  const top = rectTop + offsetTop - buffer;

  window.scrollTo({
    top,
    behavior: "smooth"
  });
});

/* ----------------------------------
ヘッダー動作
---------------------------------- */
const header = document.querySelector('.ly_header');
if(document.querySelector('.un_new2024Firstview') ) {
  const headHiddenOptions = {
    root: null, // 今回はビューポートをルート要素とする
    rootMargin: "", // ビューポートの中心を判定基準にする
    threshold: 0 // 閾値は0
  };
  const fvObserver = new IntersectionObserver(doHidden, headHiddenOptions);
  fvObserver.observe(document.querySelector('.un_new2024Firstview'));
  function doHidden(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        header.classList.add('in-firstview');
      }else{
        header.classList.remove('in-firstview');
      }
    });
  }
}

// 店舗リスト一覧
$(function(){
  if( $('.js_storeList').length ) {
    $('.js_storeList').on('click',function(){
      $(this).next().slideToggle();
    });
  }
});

// 新規獲得CPボタン表示（ログアウト時のみ表示）
$(function(){
  if ($.cookie('ecLoggedIn') != "true") {
    // ログインしていなかった場合
    $("#js_newRegist").show();
  }
});

// adobe fonts 初期化
(function(d) {
	var config = {
		kitId: 'zkg3ton',
		scriptTimeout: 3000,
		async: true
	},
	h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
})(document);

/* ----------------------------------
商品購入ボタン（_productbuybutton.pug インクルードページのみ）
発売日を過ぎたら有効化・購入先を選ぶ／ご購入はこちらに切り替え
---------------------------------- */
(function initProductBuyButton() {
  var DEBUG = false;
  var RELEASE_HOUR_JST = 10;

  function run() {
    if (!document.querySelector('.js_product_buy_btn')) return;

    function debugLog() {
      if (DEBUG && console && typeof console.log === 'function') {
        console.log.apply(console, arguments);
      }
    }

    var JST_OFFSET_MS = 9 * 60 * 60 * 1000;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function getToday10amJST(momentDate) {
      var d = momentDate ? new Date(momentDate.getTime()) : new Date();
      var jstMoment = new Date(d.getTime() + JST_OFFSET_MS);
      var y = jstMoment.getUTCFullYear();
      var m = jstMoment.getUTCMonth();
      var day = jstMoment.getUTCDate();
      return new Date(y + '-' + pad(m + 1) + '-' + pad(day) + 'T' + pad(RELEASE_HOUR_JST) + ':00:00+09:00');
    }
    function parseReleaseDateJST(str) {
      if (!str || typeof str !== 'string') return null;
      var normalized = str.replace(/\//g, '-').split('T')[0].split(' ')[0];
      var parsed = new Date(normalized + 'T' + pad(RELEASE_HOUR_JST) + ':00:00+09:00');
      return isNaN(parsed.getTime()) ? null : parsed;
    }
    function updateBuyButtons(currentDate) {
      var btns = document.querySelectorAll('.js_product_buy_btn');
      var baseDate = currentDate || new Date();
      var baseTime = baseDate.getTime ? baseDate.getTime() : NaN;
      if (isNaN(baseTime)) return;
      debugLog('[product buy] 取得した基準日時:', baseDate.toISOString ? baseDate.toISOString() : String(baseDate), currentDate ? '(サーバー)' : '(クライアント fallback)');
      btns.forEach(function(btn, idx) {
        var releaseDateStr = btn.getAttribute('data-release-date');
        var ecLinksJson = btn.getAttribute('data-ec-links');
        var isMulti = btn.getAttribute('data-is-multi') === 'true';
        if (!releaseDateStr || !ecLinksJson) return;
        var releaseDateJST = parseReleaseDateJST(releaseDateStr);
        if (!releaseDateJST) {
          debugLog('[product buy] ボタン#' + idx + ' data-release-date="' + releaseDateStr + '" → パース失敗');
          return;
        }
        var release10amTime = releaseDateJST.getTime();
        var isPast = baseTime >= release10amTime;
        debugLog('[product buy] ボタン#' + idx + ' 発売日:', releaseDateStr, '→', releaseDateJST.toISOString(), '(発売日' + RELEASE_HOUR_JST + ':00 JST) | 発売日過ぎ:', isPast, '(現在時刻 >= 発売日' + RELEASE_HOUR_JST + ':00 JST)');
        var mainAnchor = btn.querySelector('.js_product_buy_main, .un_new2026_btn_buy > a');
        if (isPast) {
          btn.classList.remove('un_new2026_btn_buy__disabled');
          if (mainAnchor) {
            if (isMulti) {
              mainAnchor.textContent = '購入先を選ぶ';
              mainAnchor.href = 'javascript:void(0)';
            } else {
              mainAnchor.innerHTML = '<i class="fas fa-shopping-cart"></i> ご購入はこちら';
              try {
                var links = JSON.parse(ecLinksJson);
                if (links.length > 0) mainAnchor.href = links[0][0];
              } catch (e) {}
            }
          }
        } else if (mainAnchor) {
          var isSingleEcLink = false;
          try {
            var ecLinksPre = JSON.parse(ecLinksJson);
            isSingleEcLink = Array.isArray(ecLinksPre) && ecLinksPre.length === 1;
          } catch (e) {}
          if (!isSingleEcLink) {
            mainAnchor.href = 'javascript:void(0)';
          }
        }
      });
    }
    function getServerDate(callback) {
      debugLog('[product buy] サーバー日時を取得中...');
      // ローカル（file:// や一部の dev server）では fetch 失敗や Date ヘッダーなしで null になり、
      // updateBuyButtons 内で new Date()（クライアントの現在日時）が使われる
      fetch(window.location.href, { method: 'GET', cache: 'no-store' })
        .then(function(response) {
          var dateHeader = response.headers.get('Date');
          var date = dateHeader ? new Date(dateHeader) : null;
          if (date) {
            debugLog('[product buy] サーバー Date ヘッダー取得:', dateHeader, '→', date.toISOString());
          } else {
            debugLog('[product buy] サーバー Date ヘッダーなし → クライアント日時を使用');
          }
          callback(date);
        })
        .catch(function(err) {
          debugLog('[product buy] fetch 失敗 → クライアント日時を使用', err && err.message);
          callback(null);
        });
    }
    function bindMultiButtons() {
      document.querySelectorAll('.un_new2026_btn_buy__multi').forEach(function(wrap) {
        var main = wrap.querySelector('.js_product_buy_main');
        var sub = wrap.querySelector('.js_product_buy_sub');
        var closeBtn = wrap.querySelector('.js_product_buy_close');
        if (!main || !sub || !closeBtn) return;
        main.addEventListener('click', function(e) {
          if (sub.classList.contains('is-closed')) {
            e.preventDefault();
            wrap.classList.add('is-sub-open');
            sub.classList.remove('is-closed');
            sub.setAttribute('aria-hidden', 'false');
          }
        });
        closeBtn.addEventListener('click', function() {
          wrap.classList.remove('is-sub-open');
          sub.classList.add('is-closed');
          sub.setAttribute('aria-hidden', 'true');
        });
      });
    }
    bindMultiButtons();
    getServerDate(function(serverDate) {
      updateBuyButtons(serverDate || new Date());
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();



/* ----------------------------------
photoswipe
---------------------------------- */
$(function(){
  var leftArrowSVGString = '<svg xmlns="http://www.w3.org/2000/svg" class="pswp__icn" viewBox="0 0 19.57 36.31"><path data-name="パス 34" d="M18.86.71 1.41 18.16l17.45 17.45" fill="none" stroke="#000" stroke-width="2"/></svg>';

  var closeSVGString = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.41 25.41" aria-hidden="true" class="pswp__icn"><g fill="none" stroke="currentColor" stroke-width="2"><path d="m.7.7 24 24"/><path d="m24.7.7-24 24"/></g></svg>';

  var photo_gallery = new PhotoSwipeLightbox({
    gallery: 'body',
    children: '.js_pswp',
    bgOpacity: 1,
    pswpModule: PhotoSwipe,
    arrowPrevSVG: leftArrowSVGString,
    arrowNextSVG: leftArrowSVGString
  });

  // ▼ 各アイテムのデータにキャプションを追加
  photo_gallery.on('itemData', function (e) {
    const linkElement = e.itemData.element;
    if (linkElement) {
      // .un_new2026_productExtra_item_caption要素からキャプションを取得
      const parentItem = linkElement.closest('.un_new2026_productExtra_item');
      if (parentItem) {
        const captionElement = parentItem.querySelector('.un_new2026_productExtra_item_caption');
        if (captionElement) {
          e.itemData.title = captionElement.textContent;
        }
      }
      // 見つからない場合はimgタグのalt属性から取得
      if (!e.itemData.title) {
        const img = linkElement.querySelector('img');
        if (img && img.getAttribute('alt')) {
          e.itemData.title = img.getAttribute('alt');
        }
      }
    }
  });

  // ▼ ここでカスタム close ボタンを登録
  photo_gallery.on('uiRegister', function () {
    photo_gallery.pswp.ui.registerElement({
      name: 'custom-close',
      order: 20,          // デフォルト close と同じくらいの順序
      isButton: true,
      ariaLabel: 'Close',
      html: closeSVGString,
      onClick: function (event, el, pswp) {
        pswp.close();
      }
    });

    // ▼ カスタムキャプション要素を登録
    photo_gallery.pswp.ui.registerElement({
      name: 'custom-caption',
      order: 9,
      isButton: false,
      appendTo: 'root',
      html: '<div class="pswp__custom-caption-inner"></div>',
      onInit: function (el, pswp) {
        pswp.on('change', function () {
          const captionHTML = pswp.currSlide.data.title || '';
          el.querySelector('.pswp__custom-caption-inner').innerHTML = captionHTML;
        });
      }
    });
  });

  photo_gallery.init();
});

/* ----------------------------------
zoomボタンクリック時にfigure内のa要素をクリック
---------------------------------- */
$(function(){
  $('.un_new2026_productExtra_item_zoom a').on('click', function(e){
    e.preventDefault();
    var $parentItem = $(this).closest('.un_new2026_productExtra_item');
    var $figureLink = $parentItem.find('figure a');
    if($figureLink.length > 0){
      $figureLink[0].click();
    }
  });
});

/* ----------------------------------
firstviewのzoomボタンクリック時にfirstview_product内のa.js_pswpをクリック
---------------------------------- */
$(function(){
  $('.un_new2024Firstview_head_zoom a').on('click', function(e){
    e.preventDefault();
    var $parentFirstview = $(this).closest('.un_new2024Firstview.un_new2026_firstview');
    var $pswpLink = $parentFirstview.find('.un_new2026_firstview_product a.js_pswp');
    if($pswpLink.length > 0){
      $pswpLink[0].click();
    }
  });
});